import classnames from 'classnames'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_TIME_OPTIONS_DIALOG } from '../../routes'
import { navigateTo } from '../../store/history/history.actions'
import { getItineraryTimeTitle } from '../../store/itineraryOptions/itineraryTimeOptions.selectors'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import calendar from '../genericComponents/assets/calendar.svg?raw'
import { useTranslateAsObject } from '../i18n/T'
import { useAction } from '../utils/react-redux'
import s from './OptionButton.less'

const ItineraryTimeOptionButton = ({ className }) => {
  const getLocaleTitle = useSelector(getItineraryTimeTitle)
  const locale = useSelector(selectLocale)
  const execNavigateTo = useAction(navigateTo)
  const onClick = useCallback(() => execNavigateTo({ route: ROUTE_ITINERARY_TIME_OPTIONS_DIALOG }), [])
  const itineraryTimeTranslations = useTranslateAsObject([
    'itinerary.options.date.start',
    'itinerary.options.date.end',
    'date.now',
    'date.today',
    'date.tomorrow',
    'date.the',
    'date.at'
  ])

  return (
    <div className={classnames(s.OptionButton, className)} onClick={onClick}>
      <div className={classnames('icon', s.icon, s.iconCalendar)} dangerouslySetInnerHTML={{ __html: calendar }}></div>
      <span>{getLocaleTitle(locale, itineraryTimeTranslations)}</span>
    </div>
  )
}

export default ItineraryTimeOptionButton
